/**
 * Property Item Scoff
 * 
 * @Author: Focci
 * @Date: 2023-08-07 21:30:56
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-07 21:30:56
 */

import PropTypes from 'prop-types'
import clsx from 'clsx'

export default function PropertyItemScoff({
  title,
  titleClassName = '',
  border = true,
  moduleName = '',
  id = '',
  children,
  meta,
  action,
  innerRef
}) {
  return (
    <div 
      className={clsx([
        'mt-6 md:mt-10 max-w-screen', 
        border && 'border-t pt-6 md:pt-10'
      ])}
      data-modulename={moduleName}
      id={id}
      ref={innerRef}
    >
      <div className={clsx(['flex items-center justify-between gap-1', titleClassName])}>
        <div>
          {title && (
            <h2 className="text-f1.2 font-medium">
              {title}
            </h2>
          )}
          {meta}
        </div>
        {action}
      </div>
      <div className="mt-6">
        {children}
      </div>
    </div>
  )
}

PropertyItemScoff.propTypes = {
  title: PropTypes.node,
  titleClassName: PropTypes.string,
  border: PropTypes.bool,
  children: PropTypes.node,
  meta: PropTypes.node,
  action: PropTypes.node,
  innerRef: PropTypes.func,
}
